import { Commission, CommissionPaginationRequest, CommissionResponse } from '@/model/commission'
import { Pagination } from '@/model/Pagination'
import Api from '@/apis/Api'

const api = new Api('commission')

export const create = (data: Commission): Promise<void> => api.create(data)
export const update = (id: number, data: Commission): Promise<void> => api.update(id, data)
export const findById = (id: number): Promise<CommissionResponse> => api.findById(id)
export const deleteByIds = (ids: string): Promise<void> => api.deleteByIds(ids)
export const deleteByIdArray = (ids: Array<number>): Promise<void> => api.deleteByIdArray(ids)
export const page = (params: CommissionPaginationRequest): Promise<Pagination<CommissionResponse>> => api.page(params)
